import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
standalone: false,
  selector: 'app-consents-accepted-dialog',
  templateUrl: './consents-accepted-dialog.component.html',
  styleUrls: ['./consents-accepted-dialog.component.scss'],
})
export class ConsentsAcceptedDialogComponent {
  constructor(private router: Router) {
  }

  public close(): void {
    this.router.navigate(['/dashboard']);
  }
}
